import { DEFAULT_CUTDOWN_CARD_UNITS } from '@/components/CutdownCard';
import type { CutdownCardBlockData } from '@/components/canvas/blocks/types';

/** 倒计时卡片在 scale=1 时的内容固有尺寸（与 CutdownCard 默认参数一致） */
export function estimateCutdownCardContentSize(data: CutdownCardBlockData): {
  width: number;
  height: number;
} {
  const cardSize = data.cardSize ?? 72;
  const gap = data.gap ?? 8;
  const units = data.units ?? DEFAULT_CUTDOWN_CARD_UNITS;
  const count = Math.max(1, units.length);
  const direction = data.layout ?? 'horizontal';

  if (direction === 'vertical') {
    return {
      width: cardSize,
      height: count * cardSize + Math.max(0, count - 1) * gap,
    };
  }
  return {
    width: count * cardSize + Math.max(0, count - 1) * gap,
    height: cardSize,
  };
}

export function fitScaleForBlockBounds(
  data: CutdownCardBlockData,
  bounds: { width: number; height: number },
): number {
  const baseScale = data.scale ?? 1;
  const content = estimateCutdownCardContentSize(data);
  if (content.width <= 0 || content.height <= 0) return baseScale;
  const fit = Math.min(bounds.width / content.width, bounds.height / content.height);
  return baseScale * fit;
}
